import React, { useEffect, useRef } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const StreamChatContainer: React.FC<any> = (props) => {
  const { property } = props;
  const ref: any = useRef(null);

  useEffect(() => {
    if (!property || !property.text || property.text.length === 0) {
      return;
    }

    if (ref && ref.current) {
      const element = ref.current;
      element.scrollTo({
        top: element.scrollHeight,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [property]);

  const handleScroll = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <div
      ref={ref}
      className="custom-scrollbar markdown"
      style={{ overflowY: 'scroll', overscrollBehavior: 'contain', height: '100%' }}
      onScroll={handleScroll}
    >
      <Markdown
        remarkPlugins={[remarkGfm]}
        // rehypePlugins={[rehypeRaw]}
      >
        {property?.text}
      </Markdown>
    </div>
  );
};

export default StreamChatContainer;
